module.exports = __webpack_public_path__ + "img/logo-light.545396cc.png";